import {createContext, useContext, useEffect, useState} from 'react';
import {TokenContext} from './TokenContext';
import {getAuthorizations} from '../Utils/accountApi';

const AuthorizationsContext = createContext({
    authorizations: [],
    loading: true,
    hasAuthorization: () => false,
});

function AuthorizationsProvider({children}) {
    const {isAuthenticated} = useContext(TokenContext);
    const [authorizations, setAuthorizations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!isAuthenticated) {
            setAuthorizations([]);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);

        // L'échec initial peut être transitoire (introspection en cours de
        // stabilisation juste après connexion/déploiement) — on retente quelques
        // fois avant d'abandonner et de vider le menu.
        const MAX_ATTEMPTS = 3;
        const fetchWithRetry = async () => {
            for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
                try {
                    const result = await getAuthorizations();
                    if (!cancelled) setAuthorizations(result);
                    return;
                } catch (error) {
                    const isLastAttempt = attempt === MAX_ATTEMPTS - 1;
                    if (isLastAttempt) {
                        console.error('Erreur lors du chargement des autorisations:', error);
                        if (!cancelled) setAuthorizations([]);
                        return;
                    }
                    await new Promise((resolve) => setTimeout(resolve, 500 * (attempt + 1)));
                }
            }
        };

        fetchWithRetry().finally(() => {
            if (!cancelled) setLoading(false);
        });

        return () => {
            cancelled = true;
        };
    }, [isAuthenticated]);

    const hasAuthorization = (key) => authorizations.includes(key);

    return (
        <AuthorizationsContext.Provider value={{authorizations, loading, hasAuthorization}}>
            {children}
        </AuthorizationsContext.Provider>
    );
}

export {AuthorizationsContext, AuthorizationsProvider};
